import React, { useRef, useEffect } from "react";
import Icon from "../../../../../../common/Icon";
import BarChartComponent from "../components/charts/BarChartComponent.js";
import PieChartComponent from "../components/charts/PieChartComponent.js";
import {
  CloseButton,
  CompletedSurveyContainer,
  ModalButton,
  ModalCloseHeader,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ProductBoxDetail,
  ProductBoxEmails,
  ProductBoxInner,
  ProductBoxTitle,
  ProductExperienceBox,
  BackButton,
  ButtonText,
} from "../styles.js";
import SurveyLoader from "../components/SurveysLoader.js";
import { ModalOverlay } from "../styles.js";
import { ExportCSV } from "../../../../../../common/utils.js";

const UserSurveyAggregateModal = ({
  userSurveyAggregate,
  setUserSurveyAggregate,
  setSurveyAggregateLoading,
}) => {
  const handleCloseModal = () => {
    setUserSurveyAggregate(null);
    setSurveyAggregateLoading(false);
  };

  const exportDataHandler = () => {
    const labels = [];
    const dataKeys = [];

    const row = {};

    userSurveyAggregate?.questions?.forEach((question, index) => {
      labels.push(question.question);
      dataKeys.push(`q${index}`);

      const ansKeys = Object.keys(question?.aggregate || {});
      const answers = ansKeys.map((key) =>
        key === "Count"
          ? question.aggregate[key]
          : `${key}: ${question.aggregate[key]}`
      );
      const joinedAnswers = answers.join(", ");
      row[`q${index}`] = joinedAnswers;
    });

    // labels.push("Users");
    // dataKeys.push("users");
    // row["users"] = userSurveyAggregate?.emails?.join(", ");

    const data = [row];

    // console.log("Labels:", labels);
    // console.log("dataKeys:", dataKeys);
    // console.log("Data:", data);

    // const escapeCSVValue = (value) => {
    //   if (
    //     typeof value === "string" &&
    //     (value.includes(",") || value.includes("\n") || value.includes('"'))
    //   ) {
    //     return `"${value.replace(/"/g, '""')}"`; // Escape inner double quotes
    //   }
    //   return value;
    // };

    // const finalLabels = [...labels].map(escapeCSVValue);

    ExportCSV({
      labels: labels,
      // labels: finalLabels,
      dataKeys: dataKeys,
      tableData: data,
      fileName: "Product Experience Aggregate Report",
    });
  };
  const modalRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setSurveyAggregateLoading(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setSurveyAggregateLoading]);

  return (
    <ModalOverlay>
      <CompletedSurveyContainer ref={modalRef}>
        {/* header */}

        <ModalHeader>
          {/* <ModalTitle>Product Experience Aggregate report</ModalTitle> */}
          <ModalTitle>{userSurveyAggregate?.name}</ModalTitle>
          <ModalCloseHeader>
            <CloseButton onClick={handleCloseModal}>
              <span>
                <Icon type="close"></Icon>
              </span>
            </CloseButton>
          </ModalCloseHeader>
        </ModalHeader>

        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginBottom: "16px",
            paddingRight: "25px",
          }}
        >
          <BackButton style={{ padding: "6px" }} onClick={exportDataHandler}>
            <Icon type="export-2" />
            <ButtonText>Export</ButtonText>
          </BackButton>
        </div>
        {/* Charts List  */}
        {userSurveyAggregate ? (
          userSurveyAggregate?.questions?.map((question, i) => {
            return (
              <>
                {question?.type === "free-response" ? (
                  <ProductExperienceBox isFreeResponse={true}>
                    <ProductBoxDetail>
                      <ProductBoxTitle>{question?.question}</ProductBoxTitle>
                    </ProductBoxDetail>

                    <ul>
                      {question?.userAnswers?.map((answer, index) => {
                        return (
                          <li key={index}>
                            <ProductBoxTitle>{answer?.answer}</ProductBoxTitle>
                          </li>
                        );
                      })}
                    </ul>
                  </ProductExperienceBox>
                ) : (
                  <ProductExperienceBox>
                    <ProductBoxDetail>
                      <ProductBoxTitle>{question?.question}</ProductBoxTitle>
                    </ProductBoxDetail>
                    <ProductBoxInner>
                      <ProductBoxEmails>
                        {i % 2 === 0 ? (
                          <PieChartComponent {...{ question }} />
                        ) : (
                          <BarChartComponent {...{ question }} />
                        )}
                      </ProductBoxEmails>
                    </ProductBoxInner>
                  </ProductExperienceBox>
                )}
              </>
            );
          })
        ) : (
          <SurveyLoader text={"Survey Aggregate"} />
        )}

        <ModalFooter>
          <ModalButton variant="cancel" onClick={handleCloseModal}>
            Close
          </ModalButton>
        </ModalFooter>
      </CompletedSurveyContainer>
    </ModalOverlay>
  );
};

export default UserSurveyAggregateModal;
